export const usersFromGroup = state => groupname => {
  return state.users[groupname] || []
}
